<template>
  <div class="biddingMethod">
    <div class="biddingMethod_titleArea">
      <div class="title_left">
        <h3 class="title">出价方式</h3>
        <span class="text">智能优化（oCPM）出价方式下，不再限制分城市等级出价。</span>
      </div>
    </div>
    <div class="biddingMethod_main">
      <div class="main_item">
        <button v-for="item,index in objall.bid_type" :key="index" :class="{ myActive: item === itemActive }" class="button" @click="handlebtn(item)">{{ item }}</button>
      </div>
      <div v-if="itemActive !== 'CPM'" class="main_item">
        <div class="item_title">
          <span class="title">投放模式</span>
        </div>
        <div class="item_main">
          <el-radio
            v-model="deliveryMode"
            label="1"
            @change="toufangbtn"
          >均衡投放</el-radio>
          <el-radio
            v-model="deliveryMode"
            label="2"
            @change="toufangbtn"
          >优先跑量</el-radio>
          <el-radio
            v-model="deliveryMode"
            label="3"
            @change="toufangbtn"
          >优先成本</el-radio>
        </div>
      </div>
      <div v-if="itemActive !== 'CPM'" class="main_item">
        <div class="item_title">
          <span class="title">优化目标</span>
        </div>
        <div class="item_main">
          <!-- <el-radio
            v-for="(item,index) in objall.optimization_objective"
            :key="index "
            v-model="optimizationObjectives"
            :label="item.label"
            @change="handle"
          >{{ item.text }}</el-radio> -->

          <el-radio
            v-for="(item,index) in objall.optimization_objective"
            :key="index "
            v-model="optimizationObjectives"
            :label="item.label"
            @change="handle"
          >{{ item.text }}</el-radio>

        </div>
      </div>
      <!-- <div v-if="signoutShow==='PRODUCTTYPE_LEAD_AD'" class="main_item">
        <div class="item_title">
          <span class="title">优化目标2</span>
        </div>
        <div class="item_main">
          <el-radio
            v-model="optimizationObjectives"
            label="1"
          >点击</el-radio>
          <el-radio
            v-model="optimizationObjectives"
            label="2"
          >下单</el-radio>
        </div>
      </div> -->
      <!-- <div v-if="signoutShow==='PRODUCTTYPE_WECHAT'" class="main_item">
        <div class="item_title">
          <span class="title">优化目标3</span>
        </div>
        <div class="item_main">
          <el-radio
            v-model="optimizationObjectives"
            label="1"
          >点击</el-radio>
          <el-radio
            v-model="optimizationObjectives"
            label="2"
          >关注</el-radio>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { getManagement/*,  createAdGroup , createAdvertisingPlan, createAdvertisingIdeas*/ } from '@/api/legacyPlan.js'
export default {
  props: {
    strategy_opt: {},
    bid_strategy: {}
    // objall: {} // 请求过来的显示什么 服务器的数据

  },
  data() {
    return {
      objall: {},
      bendistrategy_opt: {
        bid_objective: '',
        bid_action_type: '',
        bid_objective_mode: ''
      },
      bendistrategy_opt1: {
        bid_objective: 2,
        bid_action_type: 1,
        bid_objective_mode: 1
      },
      bendistrategy_opt3: {
        bid_objective: '',
        bid_action_type: '',
        bid_objective_mode: ''
      },
      deliveryMode: '',
      optimizationObjectives: '',
      signoutShow: '',
      itemActive: '',
      youhuaarr: [
        {
          text: '点击',
          label: 1,
          strategy_opt: {
            bid_objective: 2,
            bid_action_type: 2,
            bid_objective_mode: 1
          }
        },
        {
          text: '跳转按钮点击',
          label: 2,
          strategy_opt: {
            bid_objective: 10,
            bid_action_type: 10,
            bid_objective_mode: 1
          }
        }
      ],
      youhuaarrone: [
        {
          text: '点击',
          label: 1,
          strategy_opt: {
            bid_objective: 2,
            bid_action_type: 2,
            bid_objective_mode: 1
          }
        },
        {
          text: '跳转按钮点击',
          label: 2,
          strategy_opt: {
            bid_objective: 10,
            bid_action_type: 10,
            bid_objective_mode: 1
          }
        }
      ]
    }
  },
  mounted() {
  },
  beforeMount() {
    // this.signoutShow = sessionStorage.getItem('product')
  },
  created() {
    this.promotion_objective = sessionStorage.getItem('promotion_objective')
    this.deliveryposition = sessionStorage.getItem('deliveryposition')
    this.site = sessionStorage.getItem('site')
    this.getxuanxiang()
    this.getonwbs()
    this.deliveryMode = String(this.bid_strategy)
    // if (this.strategy_opt.bid_objective !== '') {
    //   this.getonloadone()
    // }

    // console.log('this.objall', this.objall)
    // console.log('this.strategy_opt', this.strategy_opt)
    // console.log('this.bid_strategy', this.bid_strategy)
    // 投放模式初始化 1均衡投放 2优先跑量 3优先成本 注意：cpm不传这个字段
  },
  methods: {
    // 获取本次选项
    getxuanxiang() {
      getManagement({
        promotion_objective: this.promotion_objective,
        position: this.deliveryposition,
        site: this.site
      }).then(res => {
        this.objall = res.data
        this.getonloadone()
        console.log(res.data)
        console.log('res', res)
      })
    },

    getonwbs() {
      // 初始化出价方式 如果为cpm 2-1-1 选中哪项
      if (this.strategy_opt.bid_objective === 2 && this.strategy_opt.bid_action_type === 1 && this.strategy_opt.bid_objective_mode === 1) {
        this.itemActive = 'CPM'
        console.log('cpm ')
      } else {
        this.itemActive = '智能优化（oCPM）'
        this.bendistrategy_opt.bid_objective = this.strategy_opt.bid_objective
        this.bendistrategy_opt.bid_action_type = this.strategy_opt.bid_action_type
        this.bendistrategy_opt.bid_objective_mode = this.strategy_opt.bid_objective_mode
      }
      console.log('this.itemActive', this.itemActive)
      // 初始化要传的值
    },
    // 初始化传进来的选项 传进来数据为空 不执行
    getonloadone() {
      // 初始化优化目标选项
      console.log('this.strategy_opt', this.strategy_opt)
      const index = this.objall.optimization_objective.findIndex(item => {
        return item.strategy_opt.bid_objective === this.strategy_opt.bid_objective && item.strategy_opt.bid_action_type === this.strategy_opt.bid_action_type && item.strategy_opt.bid_objective_mode === this.strategy_opt.bid_objective_mode
      })

      if (index === -1) {
        // console.log('没找到上次对应值的参数')
        // this.$emit('bendistrategyopt', this.bendistrategy_opt3)
        if (this.strategy_opt.bid_objective === 2 && this.strategy_opt.bid_action_type === 1 && this.strategy_opt.bid_objective_mode === 1) {
          console.log('cpm')
        } else {
          this.$emit('bendistrategyopt', this.bendistrategy_opt3)
          console.log('智能优化')
        }

        //  没找到上次对应值的参数
      } else {
        this.optimizationObjectives = this.objall.optimization_objective[index].label
        console.log('找到上次对应值的参数')
      }
    },
    handle(val) {
      // 点击获取label
      console.log(val, this.optimizationObjectives)
      const index = this.objall.optimization_objective.findIndex(item => {
        return item.label === this.optimizationObjectives
      })
      // console.log('index', index, this.objall.optimization_objective[index].strategy_opt)

      this.bendistrategy_opt.bid_action_type = this.objall.optimization_objective[index].strategy_opt.bid_action_type
      this.bendistrategy_opt.bid_objective = this.objall.optimization_objective[index].strategy_opt.bid_objective
      this.bendistrategy_opt.bid_objective_mode = this.objall.optimization_objective[index].strategy_opt.bid_objective_mode
      this.$emit('bendistrategyopt', this.bendistrategy_opt)
    },
    handlebtn(item) {
      if (item === 'CPM') {
        this.itemActive = item
        console.log('CPM')
        this.$emit('bendistrategyopt', this.bendistrategy_opt1)
        this.$emit('toufangset', '')
      }
      if (item === '智能优化（oCPM）') {
        this.itemActive = item
        //   this.bendistrategy_opt.bid_objective
        // this.bendistrategy_opt.bid_action_type
        // this.bendistrategy_opt.bid_objective_mode

        // console.log('this.bendistrategy_opt', this.bendistrategy_opt)
        this.$emit('toufangset', this.deliveryMode)
        this.$emit('bendistrategyopt', this.bendistrategy_opt)
      }
    },
    // 投放模式选择
    toufangbtn() {
      this.$emit('toufangset', this.deliveryMode)
      console.log(this.deliveryMode)
    }
  }
}
</script>

<style scoped lang="less">
.myActive{
background-color: #ccc !important;
}
.biddingMethod {
  width: 100%;
  padding: 0 0 32px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 4%), 0 0 0 1px hsl(0deg 0% 87% / 50%);
  margin-bottom: 12px;
  .biddingMethod_titleArea {
    padding: 18px 24px;
    border-bottom: 1px solid #f2f2f2;
    .title_left {
      .title {
        margin-bottom: 2px;
        font-size: 14px;
        line-height: 24px;
        color: #1f1f1f;
        font-weight: 600;
      }
      .text {
        font-size: 12px;
      }
    }
  }
}
.biddingMethod_main {
  padding: 0px 24px;
  .main_item {
    display: flex;
    margin: 10px 0px;
    .button {
      outline: none;
      width: 160px;
      height: 30px;
      color: #1f1f1f;
      background-color: #fff;
      box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.03), 0 0 0 1px #e0e0e0;
      border: none;
      cursor: pointer;
      &:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
      &:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }
      &.active {
        background-color: #ebebeb;
        box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 0 0 1px #d6d6d6;
      }
      &:not(.active):hover {
        background-color: #f2f2f2;
        box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.03), 0 0 0 1px #d6d6d6;
      }
    }

    .item_title {
      width: 110px;
      .title {
      }
    }

    .item_main {
      display: flex;
    }
  }
}
</style>
